import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

// data
import { QUEUES } from "../../constants";

// components
import PhotoModQueuePageContent from "../../components/PhotoModQueuePageContent";

const VisualQueuePage = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={[path, `${path}/:filter`]}>
                <PhotoModQueuePageContent currentQueue={QUEUES.VIS_MOD} />
            </Route>
        </Switch>
    );
};

export default VisualQueuePage;
